import React from "react";
import { ScrollView, StyleSheet } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import Header from "./Header";
import Content from "./Content";

const AddBankDetails = ({ navigation, route }) => {
  return (
    <SafeAreaView style={styles.container}>
      {/* <ScrollView> */}
      <Header params={route.params} navigation={navigation} />
      <Content params={route.params} navigation={navigation} />
      {/* </ScrollView> */}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#f7f7f7",
  },
});

export default AddBankDetails;
